module.exports = __webpack_public_path__ + "img/1.88cbb7fb.png";